//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import bus from "../../common/bus";
import Tools from "../../common/Tools";
import api from "../../../api/api.js";
import apiAllSystem from "../../../api/apiAllSystem.js";
export default {
  name: 'taskCreate',
  components: {},
  data: function data() {
    return {
      labelPosition: "top",
      pagesize: 10,
      //每页显示条数
      curPage: 1,
      //当前页数         
      multipleSelection: [],
      ruleForm: {
        company: "",
        group: "",
        task_name: "",
        task_type: ""
      },
      companySelect: [],
      groupSelect: [],
      tableData: [],
      loading: false,
      autoMatch: true
    };
  },
  computed: {
    rules: function rules() {
      return {
        company: [{
          required: true,
          message: this.$t('Rules.require'),
          trigger: 'blur'
        }],
        group: [{
          required: true,
          message: this.$t('Rules.require'),
          trigger: 'blur'
        }],
        task_name: [{
          required: true,
          message: this.$t('Rules.require'),
          trigger: 'blur'
        }],
        task_type: [{
          required: true,
          message: this.$t('Rules.require'),
          trigger: 'blur'
        }]
      };
    }
  },
  created: function created() {
    this.getCompany();
    this.getGroup();
  },
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getCompany: function getCompany() {
      var _this = this;

      var params = {
        usersssid: localStorage.getItem('sssid')
      };
      api.getUserSummary(params).then(function (res) {
        if (res.state) {
          _this.companySelect = [{
            id: 1,
            label: "公司1"
          }, {
            id: 2,
            label: "公司2"
          }, {
            id: 3,
            label: "公司3"
          }];
        } else {
          _this.$message.error(res.value.text);
        }
      }).catch(function (error) {
        _this.$message.error(_this.$t('Message.reqError'));
      });
    },
    getGroup: function getGroup() {
      var _this2 = this;

      var params = {
        usersssid: localStorage.getItem('sssid')
      };
      api.getUserSummary(params).then(function (res) {
        if (res.state) {
          _this2.groupSelect = [{
            id: 1,
            label: "分组1"
          }, {
            id: 2,
            label: "分组2"
          }, {
            id: 3,
            label: "分组3"
          }];
        } else {
          _this2.$message.error(res.value.text);
        }
      }).catch(function (error) {
        _this2.$message.error(_this2.$t('Message.reqError'));
      });
    },
    getFirmwareData: function getFirmwareData(key) {
      var _this3 = this;

      this.loading = true;
      var params = {
        usersssid: localStorage.getItem('sssid')
      };
      api.getUserSummary(params).then(function (res) {
        _this3.loading = false;

        if (res.state) {
          _this3.tableData = res.value;
          _this3.tableData = [{
            id: "1",
            target_file: "T711L_EFB5H130",
            product_name: "粤B 888888",
            device_imei: "866819231415011",
            device_mode: "T711L",
            device_series: "车载机",
            sn: "63013620069",
            config_file: "866819231415011_2022020111",
            firmware_ver: "T711L_EFB5H121",
            device_state: "不活跃|空闲|等待|工作中",
            connect_state: "12小时|开启",
            update_time: "2022-02-08 14:54",
            create_time: "2022-02-08 14:54"
          }, {
            id: "1",
            target_file: "T711L_EFB5H130",
            product_name: "粤B 888888",
            device_imei: "866819231415011",
            device_mode: "T711L",
            device_series: "车载机",
            sn: "63013620069",
            config_file: "866819231415011_2022020111",
            firmware_ver: "T711L_EFB5H121",
            device_state: "不活跃|空闲|等待|工作中",
            connect_state: "12小时|开启",
            update_time: "2022-02-08 14:54",
            create_time: "2022-02-08 14:54"
          }, {
            id: "1",
            target_file: "T711L_EFB5H130",
            product_name: "粤B 888888",
            device_imei: "866819231415011",
            device_mode: "T711L",
            device_series: "车载机",
            sn: "63013620069",
            config_file: "866819231415011_2022020111",
            firmware_ver: "T711L_EFB5H121",
            device_state: "不活跃|空闲|等待|工作中",
            connect_state: "12小时|开启",
            update_time: "2022-02-08 14:54",
            create_time: "2022-02-08 14:54"
          }, {
            id: "1",
            target_file: "T711L_EFB5H130",
            product_name: "粤B 888888",
            device_imei: "866819231415011",
            device_mode: "T711L",
            device_series: "车载机",
            sn: "63013620069",
            config_file: "866819231415011_2022020111",
            firmware_ver: "T711L_EFB5H121",
            device_state: "不活跃|空闲|等待|工作中",
            connect_state: "12小时|开启",
            update_time: "2022-02-08 14:54",
            create_time: "2022-02-08 14:54"
          }, {
            id: "1",
            target_file: "T711L_EFB5H130",
            product_name: "粤B 888888",
            device_imei: "866819231415011",
            device_mode: "T711L",
            device_series: "车载机",
            sn: "63013620069",
            config_file: "866819231415011_2022020111",
            firmware_ver: "T711L_EFB5H121",
            device_state: "不活跃|空闲|等待|工作中",
            connect_state: "12小时|开启",
            update_time: "2022-02-08 14:54",
            create_time: "2022-02-08 14:54"
          }]; //选中所有行

          _this3.$refs.multipleTable.toggleAllSelection();
        } else {
          _this3.$message.error(res.value.text);
        }
      }).catch(function (error) {
        _this3.$message.error(_this3.$t('Message.reqError'));
      });
    },
    onSubmit: function onSubmit(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var params = {
            company: _this4.ruleForm.company,
            group: _this4.ruleForm.group,
            task_name: _this4.ruleForm.task_name,
            task_type: _this4.ruleForm.task_type
          };
          api.addDevice(params).then(function (res) {
            if (res.state) {
              _this4.$message.success(_this4.$t('Message.success'));

              _this4.$router.push({
                path: '/taskManage'
              });
            } else {
              _this4.$message.error(res.value.text);
            }
          }).catch(function (error) {
            _this4.$message.error(_this4.$t('Message.reqError'));
          });
        }
      });
    },
    changeType: function changeType(key) {
      this.getFirmwareData(key);
    },
    //当前显示条数
    handleCurentChange: function handleCurentChange(val) {
      this.curPage = val;
    },
    //设置每页显示条数                 
    handleSizeChange: function handleSizeChange(val) {
      this.pagesize = val;
    },
    handleSelectionChange: function handleSelectionChange() {}
  }
};